export type SseRecord = Record<string, unknown> & { type?: string };

const DATA_PREFIX = 'data: ';
const DONE = '[DONE]';

// Läser en SSE-kropp och ger en post per data-rad. Servern avslutar med
// [DONE]; kommer strömmen av sig utan det avslutar vi ändå när kroppen tar
// slut — men då lämnas läsaren utan cancel, eftersom det inte var vi som
// bestämde att sluta lyssna.
export async function* readSseRecords(body: ReadableStream<Uint8Array>): AsyncGenerator<SseRecord> {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  let receivedDone = false;

  try {
    while (!receivedDone) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split(/\r?\n/);
      buffer = lines.pop() ?? '';

      for (const rawLine of lines) {
        const line = rawLine.trim();
        if (!line.startsWith(DATA_PREFIX)) continue;

        const data = line.slice(DATA_PREFIX.length).trim();
        if (data === DONE) {
          receivedDone = true;
          break;
        }

        let record: SseRecord | null = null;
        try {
          record = JSON.parse(data) as SseRecord;
        } catch {
          console.warn('Failed to parse SSE data:', data);
        }

        if (record) yield record;
      }
    }

    // Sista raden kan sakna radbrytning och ligga kvar i bufferten.
    if (!receivedDone && buffer.trim() === `${DATA_PREFIX.trim()} ${DONE}`) {
      receivedDone = true;
    }
  } finally {
    try {
      if (receivedDone) {
        await reader.cancel();
      }
    } catch {
      // Strömmen kan redan vara stängd av servern — då kastar cancel, och det
      // är inget att rapportera. Vi är på väg att släppa läsaren ändå.
    }
    reader.releaseLock();
  }
}
